import { FORM_TYPE_CREATE_DIRECT_FLOW } from 'js/constants/formTypes';
import useFlowsSetup from 'new/components/flows/controller/useFlowsSetup';
import { useDirectFlow } from 'new/components/flows/types/DirectFlow/hooks/useDirectFlow';
import { SinkConfigureStep } from 'new/components/flows/types/DirectFlow/steps/SinkConfigureStep';
import { SourceConfigureStep } from 'new/components/flows/types/DirectFlow/steps/SourceConfigureStep';
import { CenteredLoader } from 'new/elements/CenteredLoader';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import { Stack } from 'new/elements/Stack';
import React, { useEffect } from 'react';
import useFlowType from '../hooks/useFlowType';
import useFlowParams from 'new/components/flows/useFlowParams';

const FORM = FORM_TYPE_CREATE_DIRECT_FLOW;

export const ConfigureStep: FCFormPageType<any> = () => {
  const { connectionType } = useDirectFlow();
  const form = useForm();
  const params = useFlowParams();
  const flowType = useFlowType();
  const { initialLoading } = useFlowsSetup(FORM, flowType);

  if (initialLoading) {
    return (
      <Stack padding="50px">
        <CenteredLoader />
      </Stack>
    );
  }

  useEffect(() => {
    if (params.id) {
      form.setConfirmButtonTitle('Save');
    }
  }, [params.id]);

  if (connectionType === 'SOURCE') return <SourceConfigureStep />;
  if (connectionType === 'SINK') return <SinkConfigureStep />;
  return null;
};

ConfigureStep.formConfig = {
  title: 'Configure',
};
